const ALTERNATE_PICKUP_FORM_CHANGE_VALUE = 'ALTERNATE_PICKUP_FORM_CHANGE_VALUE';
const ALTERNATE_PICKUP_FORM_ERROR = 'ALTERNATE_PICKUP_FORM_ERROR';
const ALTERNATE_PICKUP_FORM_FIELD_ERROR = 'ALTERNATE_PICKUP_FORM_FIELD_ERROR';
const INIT_BOPIS_SECTION_UI = 'INIT_BOPIS_SECTION_UI';
const SHOW_ALTERNATE_PICKUP_PERSON_FORM = 'SHOW_ALTERNATE_PICKUP_PERSON_FORM';
const SUBMIT_BOPIS_SECTION = 'SUBMIT_BOPIS_SECTION';

export {
    ALTERNATE_PICKUP_FORM_CHANGE_VALUE,
    ALTERNATE_PICKUP_FORM_ERROR,
    ALTERNATE_PICKUP_FORM_FIELD_ERROR,
    INIT_BOPIS_SECTION_UI,
    SHOW_ALTERNATE_PICKUP_PERSON_FORM,
    SUBMIT_BOPIS_SECTION,
};
